export default __webpack_public_path__ + "static/img-save-time-administrative-a4db3c508396affd26451df9926f6d5e.png";